import { Navigate, Outlet } from 'react-router';

import type { ReactNode } from 'react';

import { LoginState, useSelectLoginState } from '@treneo/features/auth';
import { urls } from '@treneo/shared/constants';
import { useAppLocation } from '@treneo/shared/router';

type AuthGuardProps = {
  children?: ReactNode;
};

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const location = useAppLocation();
  const loginState = useSelectLoginState();

  if (
    loginState === LoginState.NOT_LOGGED ||
    loginState === LoginState.LOGIN_REJECTED ||
    loginState === LoginState.LOGGING_OUT
  ) {
    return <Navigate to={urls.loginPage} state={{ from: location }} replace />;
  }

  return <>{children ?? <Outlet />}</>;
};
